module.exports = __webpack_public_path__ + "static/keytruda-lenvima-logo-mobile-f78e8b6f0c9f67ceb83996b8ea3adeb0.png";